<template>
    <div class="home_bottom">
        <div class="home_bottom_top">
            <div @click="jumpPage('about')">关于我们<div class="span">|</div></div>
            <div @click="jumpPage('introduce')">平台介绍<div class="span">|</div></div>
            <div @click="jumpPage('notice')"></div>
        </div>
        <div class="home_bottom_center">江苏好汇卖科技发展有限公司&nbsp;&nbsp;&nbsp;<span>电话：400-020-8228</span></div>
        <div class="home_bottom_bottom" @click="linkJump">版权所有©  2020江苏好汇卖科技发展有限公司  苏ICP备19075201号-1</div>
    </div>
</template>

<script>
    export default {
        data(){
            return{

            }
        },
        methods:{
            jumpPage(type){
                if (type == 'about'){
                    this.$router.push({
                        path:'/about'
                    })
                }
                if (type == 'introduce'){
                    console.log("---about",);
                    this.$router.push({
                        path:'/introduce'
                    })
                }
                if (type == 'notice'){
                    this.$router.push({
                        "path":"/newStatus"
                    });
                }
            },
            linkJump(){
                window.location.href = "https://beian.miit.gov.cn/#/Integrated/index"
            }
        }
    }
</script>

<style lang="less" scoped>
    .home_bottom{
        width: 100%;
        padding: 22px 0;
        background: #4B7FFF;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .home_bottom_top{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 13px;
            >div{
                font-size: 12px;
                font-family: Microsoft YaHei;
                font-weight: 300;
                color: rgba(255,255,255,0.8);
                cursor:pointer;
                .span{
                    display: inline-block;
                    margin: 0 7px
                }
            }
            >div:hover{
                color: rgba(255,255,255,1);
            }
        }
        .home_bottom_center{
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: 300;
            color: rgba(255,255,255,1);
            margin-bottom: 12px;
        }
        .home_bottom_bottom{
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: 300;
            color: rgba(255,255,255,0.8);
            cursor: pointer;
        }
        .home_bottom_bottom:hover{
            color: rgba(255,255,255,1);
        }
    }
</style>
